import { z } from 'zod';

export const ProxyPoolRotationSchema = z.union([
  z.literal(-1),
  z.literal(0),
  z.literal(5),
  z.literal(10),
  z.literal(15),
  z.literal(20),
  z.literal(60),
]);

export type ProxyPoolRotationType = z.infer<typeof ProxyPoolRotationSchema>;

type ProxyPoolRotationOptionsType = {
  value: ProxyPoolRotationType;
  label: string;
  shortLabel?: string;
}[];

export const proxyPoolRotationOptions: ProxyPoolRotationOptionsType = [
  { value: 0, label: 'Keep IP as long as possible', shortLabel: 'Keep IP' },
  {
    value: -1,
    label: 'On each request',
  },
  { value: 5, label: 'Every 5 minutes' },
  { value: 10, label: 'Every 10 minutes' },
  { value: 15, label: 'Every 15 minutes' },
  { value: 20, label: 'Every 20 minutes' },
  { value: 60, label: 'Every 60 minutes' },
];

export const proxyPoolRotationOptionsMap = new Map<
  ProxyPoolRotationType,
  string
>(proxyPoolRotationOptions.map((i) => [i.value, i.label]));

export const proxyPoolRotationShortLabelMap = new Map<
  ProxyPoolRotationType,
  string
>(proxyPoolRotationOptions.map((i) => [i.value, i.shortLabel ?? i.label]));
